export class CreateScanJobResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return CreateScanJobResponse.attributeTypeMap;
    }
    constructor() {
    }
}
